import React, { useEffect } from 'react'
import { Notification, NotificationGroup } from '@progress/kendo-react-notification'
const FormNotification = ({ formNotificationType, text, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            if (formNotificationType.none) onClose('none')
            if (formNotificationType.success) onClose('success')
            if (formNotificationType.error) onClose('error')
            if (formNotificationType.warning) onClose('warning')
            if (formNotificationType.info) onClose('info')
        }, 8000)

        // Cleanup timer on component unmount or when notification type changes
        return () => clearTimeout(timer)
    }, [formNotificationType, onClose])
    return (
        <React.Fragment>
            <NotificationGroup
                style={{
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap-reverse',
                    zIndex: 9999,
                }}
            >
                {formNotificationType.none && (
                    <Notification
                        type={{
                            style: 'none',
                            icon: false,
                        }}
                        closable={true}
                        onClose={() =>
                            setState({
                                ...state,
                                none: false,
                            })
                        }
                    >
                        {text}
                    </Notification>
                )}
                {formNotificationType.success && (
                    <Notification
                        type={{
                            style: 'success',
                            icon: true,
                        }}
                        closable={true}
                        onClose={onClose}
                    >
                        {text}
                    </Notification>
                )}
                {formNotificationType.error && (
                    <Notification
                        type={{
                            style: 'error',
                            icon: true,
                        }}
                        closable={true}
                        onClose={onClose}
                    >
                        {text}
                    </Notification>
                )}
                {formNotificationType.warning && (
                    <Notification
                        type={{
                            style: 'warning',
                            icon: true,
                        }}
                        closable={true}
                        onClose={onClose}
                    >
                        {text}
                    </Notification>
                )}
                {formNotificationType.info && (
                    <Notification
                        type={{
                            style: 'info',
                            icon: true,
                        }}
                        closable={true}
                        onClose={onClose}
                    >
                        {text}
                    </Notification>
                )}
            </NotificationGroup>
        </React.Fragment>
    )
}
export default FormNotification
